import React from 'react';
import { inject, observer } from 'mobx-react';

import { editingMode } from 'sdc-cms-writing';
import { editingType } from 'sdc-cms-writing';
import { fieldValue } from 'sdc-data-models';

export var MarkdownEdit = inject('indexStore')(observer(function (_ref) {
    var store = _ref.store,
        indexStore = _ref.indexStore,
        field = _ref.field,
        locale = _ref.locale,
        editStyle = _ref.editStyle;

    if (editingMode.isViewMode.get()) return null;
    if (field.display !== 'markdown') return null;
    if (editingType.typeID === null) return null;

    return React.createElement('textarea', { value: fieldValue(store._sending, field.key) || '',
        style: editStyle,
        onFocus: store.selectField(field, locale),
        onChange: store.updateField(field, locale),
        onBlur: store.updateField(field, locale, true),
        onSelect: store.textSelected,
        className: 'form-control', rows: field.height || 10 });
}));